// Sections grouped exactly as they appear in the left settings menu, in the same
// order. Each section shows subtle links to the other entries in its group
// (floated to the top-right of the header) so the user can jump between related
// sections without going back to the menu. Only the groups the product wants this
// behaviour for are listed here. Labels reuse the same translation keys the
// sidebar uses for each entry.
//
// Every entry is a plain section, switched via its key. An entry may also carry a
// `tab` for a section the menu splits into a unit-prices line and a machines line
// (SettingsTabs still honours it), but no group needs that today.
export const SIBLING_SECTION_GROUPS = [
  [
    { key: 'die_cutting_machine',     label: 'quote_builder.menu_die_cutting_machines' },
    { key: 'metal_strip',             label: 'quote_builder.menu_metal_strips' },
    { key: 'cutting_board',           label: 'quote_builder.menu_cutting_boards' },
  ],
  [
    { key: 'guillotine_machine',      label: 'quote_builder.menu_guillotine_machines' },
  ],
  [
    { key: 'cellophane_material',     label: 'quote_builder.menu_materials' },
    { key: 'cellophane_machine',      label: 'quote_builder.menu_machines' },
  ],
  [
    { key: 'glueing_machine',         label: 'quote_builder.glueing_machines' },
    { key: 'glueing_manual_labor',    label: 'quote_builder.glueing_manual_labor' },
    { key: 'glueing_material',        label: 'quote_builder.glueing_materials' },
  ],
  [
    { key: 'lamination_machine',      label: 'quote_builder.lamination_machines' },
    { key: 'lamination_manual_labor', label: 'quote_builder.lamination_manual_labor' },
  ],
  [
    { key: 'coating_machine',         label: 'quote_builder.coating_machines' },
    { key: 'coating_manual_labor',    label: 'quote_builder.coating_manual_labor' },
  ],
];

// Returns the full group (including the current section itself) so the header can
// render the current section as a disabled item alongside its siblings, keeping
// the row of links stable when switching. Empty when the section is not in a
// grouped set, or is the only entry in its group (nothing to switch between).
export const sectionGroupFor = (sectionKey) => {
  const group = SIBLING_SECTION_GROUPS.find( (g) => g.some( (s) => s.key == sectionKey ) );
  if (group == undefined || group.length < 2) { return []; }
  return group;
};
